import React from "react";
import SortButton from "../../Component/SortButton/SortButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Customer/CustomerList.css";

const Customerlistheader = ({
  columnSearch,
  setColumnSearch,
  currentSortColumn,
  currentSortOrder,
  onSortChange,
}) => {
  const renderInputColumn = (label, column) => (
    <div>
      <p>
        {label}{" "}
        <SortButton
          column={column}
          currentSortColumn={currentSortColumn}
          currentSortOrder={currentSortOrder}
          onSortChange={onSortChange}
        />
      </p>
      <input
        type="text"
        placeholder="Search"
        value={columnSearch[column]}
        onChange={(e) =>
          setColumnSearch({ ...columnSearch, [column]: e.target.value })
        }
      />
    </div>
  );

 const renderDateColumn = (label, column) => (
  <div>
    <p>
      {label}{" "}
      <SortButton
        column={column}
        currentSortColumn={currentSortColumn}
        currentSortOrder={currentSortOrder}
        onSortChange={onSortChange}
      />
    </p>

    <div style={{ height: "2.17rem" }}></div>
  </div>
);
  return (
    <div className="grid-row header">
      <div>Sr</div>
      <div>Action</div>

      {renderInputColumn("Customer Name", "customerName")}
      {renderInputColumn("Mobile", "mobile")}
      {renderInputColumn("Coins", "coins")}
      {renderInputColumn("Created By", "createdBy")}
      <div>
        <p>
          Status{" "}
          <SortButton
            column="status"
            currentSortColumn={currentSortColumn}
            currentSortOrder={currentSortOrder}
            onSortChange={onSortChange}
          />
        </p>
        <select
          name="status"
          value={columnSearch.status}
          onChange={(e) =>
            setColumnSearch({ ...columnSearch, status: e.target.value })
          }
        >
          <option value="active">Active</option>
          <option value="deactive">DeActive</option>
        </select>
      </div>
      {renderInputColumn("Company Name", "companyName")}
      {renderDateColumn("Last Login", "lastLogin")}
      {renderDateColumn("Last Transaction", "lastTransaction")}
      {renderInputColumn("Reference", "reference")}
      {renderInputColumn("Address", "address")}
      {renderInputColumn("Map Location", "mapLocation")}
    </div>
  );
};

export default Customerlistheader;
